import { luhnCheck, validateCPF } from '@shared/utils';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { useGetCustomerCard } from '../hooks';

export function CrossSellerPaymentSchema() {
  const { t } = useTranslation('validation');
  const companyId = sessionStorage.getItem('companyId');
  const { data: customerCard } = useGetCustomerCard(companyId ?? '');

  const cardIds = customerCard?.map(card => card.id) ?? [];

  const baseSchema = z.object({
    cvv: z.string().min(1, t('notEmpty')),
    expirationDate: z.string().min(1, t('notEmpty')),
    postalCode: z.string().min(1, t('notEmpty')),
    number: z.string().min(1, t('notEmpty')),
    complement: z.string(),
    street: z.string().min(1, t('notEmpty')),
    district: z.string().min(1, t('notEmpty')),
    city: z.string().min(1, t('notEmpty')),
    state: z.string().min(1, t('notEmpty')),
  });

  const newCardSchema = baseSchema.extend({
    paymentCard: z.literal('newCard'),
    cardNumber: z
      .string()
      .min(1, t('notEmpty'))
      .refine(luhnCheck, {
        message: t('invalidCardNumber'),
      }),
    name: z.string().min(1, t('notEmpty')),
    document: z
      .string()
      .min(1, t('notEmpty'))
      .refine(validateCPF, {
        message: t('invalidCPF'),
      }),
  });

  const savedCardSchema = baseSchema.extend({
    paymentCard: z.enum(
      cardIds.length ? (cardIds as [string, ...string[]]) : ['dummy'],
    ),
    cardNumber: z.string().optional(),
    name: z.string().optional(),
    document: z.string().optional(),
  });

  return z.discriminatedUnion('paymentCard', [
    newCardSchema,
    ...(cardIds.length ? [savedCardSchema] : []),
  ]);
}

export type ICrossSellerPaymentForm = z.infer<
  ReturnType<typeof CrossSellerPaymentSchema>
>;
